import { withTranslation } from "react-i18next";

const Home = ({t})=>{
  return 'Home';
};

export default withTranslation()(Home);
